import React from "react";

import LoadingIcon from "ac-components/ac-icons/LoadingIcon";

export default function ACAppLoader() {
  return (
    <div className="d-flex justify-content-center p-l m-l w-100">
      <LoadingIcon className="font-size-24" />
    </div>
  );
}
